import { useMemo } from "react";
import { useCantonContext } from "../../core/providers/CantonProvider";
import { useEvmContext } from "../../core/providers/EvmProvider";
import { useSolanaContext } from "../../core/providers/SolanaProvider";
import { useStellarContext } from "../../core/providers/StellarProvider";
import { useSuiContext } from "../../core/providers/SuiProvider";
import { useXrplContext } from "../../core/providers/XrplProvider";
import {
  multiChainWallets as unformattedMultiChainWallets,
  singleChainWallets as unformattedSingleChainWallets,
} from "../../core/wallets";
import {
  buildFallbackWallets,
  mergeWallets,
  populateWallets,
} from "../../services/internal/walletService";
import { useClient } from "../client/useClient";

export const useWallets = () => {
  const { clientWindow } = useClient();
  const { wallets: evmWallets } = useEvmContext();
  const { wallets: solanaWallets } = useSolanaContext();
  const { wallets: suiWallets } = useSuiContext();
  const { wallets: xrplWallets } = useXrplContext();
  const { wallets: stellarWallets } = useStellarContext();
  const { wallets: cantonWallets } = useCantonContext();

  const wallets = useMemo(() => {
    const singleChainWallets = populateWallets(
      clientWindow,
      unformattedSingleChainWallets
    );
    const multiChainWallets = populateWallets(
      clientWindow,
      unformattedMultiChainWallets
    );

    const discoveredWallets = [
      ...evmWallets,
      ...solanaWallets,
      ...suiWallets,
      ...cantonWallets,
    ];

    const fallbackWallets = buildFallbackWallets(discoveredWallets);

    return mergeWallets({
      singleChainWallets: [
        ...singleChainWallets,
        ...discoveredWallets,
        ...xrplWallets,
        ...stellarWallets,
        ...fallbackWallets,
      ],
      multiChainWallets,
    });
  }, [
    clientWindow,
    evmWallets,
    solanaWallets,
    suiWallets,
    xrplWallets,
    stellarWallets,
    cantonWallets,
  ]);

  return {
    wallets,
  };
};
